import React from 'react'
import { ThemeProvider } from 'styled-components'
import { useSelector } from 'react-redux'
import { WrapIcon, WrapNumChild, GraphNumber, WrapGraphItem, WrapChild } from './Style'
import { firstWord } from 'utils/obj'
import { ReactComponent as ChildIcon } from 'assets/icons/Child.svg';

//Return the number item on the bar
const BarItem = (props) => {
    const { viewItemCount, viewTestTaker, value, onClick, bold, size, current_test_taker, count, percent, index, theme, graphKey, isDrag, viewPercent, isPercent } = props
    const { testTaker = {} } = useSelector(state => state.testTaker)
    const { brokenDisplay } = useSelector(state => state.general)

    return (
        <ThemeProvider theme={theme} key={`${graphKey}-${index}`}>
            <WrapGraphItem isDrag={isDrag} viewItemCount={viewItemCount} viewTestTaker={viewTestTaker} current_test_taker={current_test_taker}>
                <React.Fragment>
                    <WrapNumChild viewItemCount={viewItemCount} viewTestTaker={viewTestTaker}>
                        {
                            <div>
                                {viewItemCount && (
                                    viewPercent ? //show the percent of count
                                        (percent ? `${percent?.toFixed(1)}%` : "") :
                                        (count > 1 && (`${count}+`))//show the count number
                                )}
                            </div>
                        }
                        {current_test_taker &&
                            <div className={`${brokenDisplay && 'blurred2'}`}>
                                {firstWord(testTaker.test_taker_name)}
                            </div>}
                    </WrapNumChild>
                    <WrapChild>
                        {(
                            // (
                            // // showAllChildren || 
                            // current_test_taker) &&
                            count >= 1 &&
                            <WrapIcon fontSize="small" component={ChildIcon} inheritViewBox />)}
                    </WrapChild>
                </React.Fragment>
                <GraphNumber size={size} bold={bold} onClick={onClick}>
                    <React.Fragment>
                        {isPercent ? Number(value)?.toFixed(0) : value}
                        {isPercent ? "%" : ""}
                    </React.Fragment>
                </GraphNumber>
            </WrapGraphItem>
        </ThemeProvider>
    )
}

export default BarItem